import Index from '@/views/exhibitor/Index.vue';
import NotFound from '@/views/exhibitor/NotFound.vue';
import account from '@/router/exhibitor/account';
import brand from '@/router/exhibitor/brand';
import booth from '@/router/exhibitor/booth';
import item from '@/router/exhibitor/item';
import contact from '@/router/exhibitor/contact';
import dashboard from '@/router/exhibitor/dashboard';
import vis from '@/router/exhibitor/vis';
import visitors from '@/router/exhibitor/visitors';

const defaultRouters: any[] = [];
const children: any[] = defaultRouters
  .concat(account.routes)
  .concat(item.routes)
  .concat(brand.routes)
  .concat(booth.routes)
  .concat(dashboard.routes)
  .concat(vis.routes)
  .concat(contact.routes)
  .concat(visitors.routes);

const routes: any[] = [
  {
    path: '/exhibitor',
    redirect: '/exhibitor/brand',
    component: Index,
    children: [
      ...children,
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
];

export default {
  routes,
};
